import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { QUALTRICS_RETAILER_SURVEY_INTERCEPT_SAMPLE_RATE_BPS } from "@faire/web-api--source/indigofair/settings/QUALTRICS_RETAILER_SURVEY_INTERCEPT_SAMPLE_RATE_BPS";

export const getSettingQualtricsRetailerSurveyInterceptSampleRateBPS = () =>
  getSettingValueWithoutAssignment(
    QUALTRICS_RETAILER_SURVEY_INTERCEPT_SAMPLE_RATE_BPS,
    0
  );
